import React from "react";
import classNames from "classnames";

import Avatar from "@components/Avatar";
import UserBadges from "@components/UserBadges";
import ChatActionDropdown from "@pages/Livestream/components/Sidebar/components/LiveChat/components/Chat/components/ChatActionDropdown";
import { HOST, roles } from "@const/livestreams";

import styles from "../index.module.scss";

const NewTextMessage = ({
  author,
  text,
  streamParticipant,
  id: messageId,
  type: messageUserType,
  streamUserType,
  isSupporter,
  isPromoter,
  isMostProfitableSupporter,
  isMostProfitablePromoter,
  chatUsernameClassName,
  textClassName,
}) => {
  const isModerator = streamParticipant.role === roles.moderator;

  return (
    <div className={classNames(styles.messageContainer)}>
      <Avatar
        avatar={author?.avatar}
        className={styles.avatarContainer}
        type={isModerator ? "moderator" : messageUserType}
      />
      <div className="w-100">
        <div className="d-flex align-items-center justify-content-between w-100">
          <div className="d-flex">
            <span
              className={classNames(
                "text-body-2 text-semibold",
                styles.chatUsername,
                chatUsernameClassName,
              )}
            >
              {author?.username}
            </span>
            <UserBadges
              isPaid={streamUserType !== HOST}
              isPromoter={isPromoter}
              isSupporter={isSupporter}
              isIdentityVerified={author?.isIdentityVerified}
              isMostProfitablePromoter={isMostProfitablePromoter}
              isMostProfitableSupporter={isMostProfitableSupporter}
            />
          </div>
          <ChatActionDropdown
            author={author}
            messageId={messageId}
            streamParticipant={streamParticipant}
          />
        </div>
        <span
          className={classNames(
            "text-body-2 text-emoji-regular message-description",
            styles.text,
            textClassName,
          )}
        >
          {text}
        </span>
      </div>
    </div>
  );
};

export default NewTextMessage;
